import {useInfiniteQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getPromotions} from '../../../apis/promotion/list'

const useQueryPromotions = active => {
    const {data, refetch, hasNextPage, fetchNextPage, isFetchingNextPage} = useInfiniteQuery({
        queryKey: QueryCacheKeys.advertisement.getPromotions(active),
        queryFn: async ({pageParam = 1}) => {
            const {data, pageInfo} = await getPromotions(active, undefined, pageParam)
            return {data, pageInfo}
        },
        // page_info 의 current_page 가 total_page 에 도달하면 마지막 페이지로 보고 더 불러오지 않는다.
        getNextPageParam: lastPage => {
            const {current_page, total_page} = lastPage?.pageInfo || {}
            if (!current_page || !total_page || current_page >= total_page) return undefined
            return current_page + 1
        },
        refetchOnWindowFocus: false,
    })

    const promotions = data?.pages?.flatMap(page => page?.data || [])
    const pageInfo = data?.pages?.at(-1)?.pageInfo

    return {data: promotions, pageInfo, refetch, hasNextPage, fetchNextPage, isFetchingNextPage}
}

export default useQueryPromotions
